<template>
    <div class="card">
        <div class="card-header">Attachments</div>
        <div class="card-body">
            <form-summary :validator="$v" ref="errorContainer" id="errorContainer"/>
            <b-row>
                <b-col cols="12" md="2" style="margin-bottom:8px;">
                    <FileAttachment
                        v-on:attachment-added="addAttachment"
                        :attachmentTypeOptions="attachmentTypeOptions"
                        describedBy="attachments"/>
                </b-col>
                <b-col cols="12" md="4" id="othAttach">
                    <strong>The following attachments are REQUIRED:</strong>
                    <p v-for="item in attachmentTypeOptions" v-bind:key="item.value"
                       style="margin-left:11px; margin-top:8px;">
                        <span v-if="hasAttachment(item.value)">
                            <b-icon icon="check2-square" scale="1.75" variant="success" aria-label="Valid"
                                    alt="Valid" role="img"></b-icon>
                        </span>
                        <span v-else>
                            <b-icon icon="x-circle" scale="1.75" variant="danger" aria-label="Invalid"
                                    alt="Invalid" role="img"></b-icon>
                        </span>
                        <span style="margin-left:12px;">{{item.text}}</span>
                    </p>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-table hover small show-empty class="sr-caption"
                             aria-live="polite"
                             responsive="true"
                             :fields="opts.attachmentFields"
                             :items="attachments"
                             :busy="false"
                             label-sort-asc=""
                             label-sort-desc=""
                             caption="Attachments table.  To sort the data in this table by a specific column,
                                go to the appropriate column header cell and use enter to sort the data ascending.
                                Use enter again to sort descending.">
                        <template v-slot:no-data>
                            No Attachments Found.
                        </template>
                        <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle" label="Loading, Please Wait" aria-label="Loading, Please Wait"/>
                            <strong>Loading...</strong>
                        </div>
                        <template v-slot:cell(actions)="row">
                            <b-button size="sm" :href="row.item.url" target="_attach" class="mr-1">
                                Download
                            </b-button>
                        </template>
                        <template slot="empty" slot-scope="scope">
                            No Attachments Found.
                        </template>
                    </b-table>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>

import FileAttachment from "@/components/templates/input/FileAttachment";
import _ from "lodash"
import axios from "axios"
import axiosRetry from "axios-retry"

axiosRetry(axios, {retries: 3, retryDelay: axiosRetry.exponentialDelay})

export default {
name: "Attachments",
    props: {
        application: [Object],
        current: [Array],
        attachmentTypeOptions: [Array],
    },
    components:{
        FileAttachment
    },
    data(){
        return {
            opts: {
                attachmentFields: [
                    {key: 'filename', sortable: true, label: 'File Name'},
                    {key: 'type', sortable: true, label: 'File Type', formatter: 'getFileType'},
                    {key: 'actions', label: 'Actions'}
                ],
            },
            attachments: [],
        }
    },
    validations(){
        return {
            haveAllAttachments: {
                reqAttach(){
                    return this.haveAllAttachments();
                }
            }
        }
    },
    methods:{
        addAttachment(value){
            this.attachments.push(value)
            this.$emit('on-validate', this.$data, true)
        },
        getFileType(value){
            const type = this.opts.attachmentTypeOptions.filter(opt => opt.value === value.code)[0];

            if(type){
                return type.text;
            }
            return null;
        },
        hasAttachment(attachmentType){
            return this.attachments.find(a=>a.type.code === attachmentType)
        },
        haveAllAttachments(){
            let haveAll = false;
            let hasReqs = this.attachmentTypeOptions.every(req => this.attachments.filter(a=>req.value === a.type.code).length > 0);
            if(this.attachments.length>0 && hasReqs){
                haveAll = true;
            }
            return haveAll;
        },
        validate(){
            this.$v.haveAllAttachments.$touch();
            let isValid = !this.$v.haveAllAttachments.$invalid;
            this.$emit('on-validate', this.$data, isValid);
            return isValid;
        }
    },
    computed: {
        _: function() {
            return _
        }
    },
    watch:{
        current() {
            if(this.current === null){
                this.attachments = [];
            }else{
                this.attachments = this.current;
            }
        },
    }

}
</script>

<style scoped>

</style>